<template>
  <div class="CorporationF">
    <PageContent>
      <StepsV2 type="s3" :step="1" />
      <PanelV2
        type="w6"
        title="State your ownership of the business"
        @nextClick="next()"
      >
        <template v-slot:title-solt>
          <BdoProgress total="4" step="3" />
        </template>
        <template v-slot:content-solt>
          <el-form :model="formData" ref="formData" :rules="formRule">
            <el-form-item label="Do you own at least 20% of the business?" prop="least20">
              <BdoRadios :value="formData.least20" @onClick="updateRadioValue" />
            </el-form-item>
          </el-form>
        </template>
      </PanelV2>
    </PageContent>
  </div>
</template>

<script>
  import API from "@/api";
  export default {
    name: 'CorporationF',
    pRouter: 'CorporationE',
    components: {
    },
    data() {
      return {
        formData: {
          least20: '1'
        },
        formRule:{
          least20: [{ required: true, message: 'least20 is error', trigger: 'change' }]
        }
      }
    },
    methods: {
      updateRadioValue(val) {
        this.formData.least20 = val
      },
      next() {
        this.$refs.formData.validate((valid) => {
          if(valid) {
            const data = this.formatCommitData({...this.formData})
            API.addBdoProcess({
              ...data
            }).then((res) => {
              if (res.success === true) {
                this.toNext();
              }
            });
          }
        })
      }
    }
  }
</script>


<style lang="scss" scoped>
.CorporationF {
  ::v-deep .content {
    margin-bottom: 192px;
  }
  .content > div {
    width: 100%;
  }
}
</style>
